import { DEFAULT_ICON_CONFIGS, IconProvider } from '@icon-park/react/es/all';

const IconConfig = {
  ...DEFAULT_ICON_CONFIGS,
  strokeWidth: 3,
  size: 24,
  colors: {
    ...DEFAULT_ICON_CONFIGS?.colors,
    outline: {
      background: 'transparent',
      fill: '#fff',
    },
  },
};

export const IconParkProvider = ({ children }) => (
  <IconProvider value={IconConfig}>{children}</IconProvider>
);
